import React from 'react';
import { useTranslation } from 'react-i18next';

import Markdown from 'components/Markdown/Markdown';

import './ColorLegend.scss';

export interface ColorLegendProps {}

const ColorLegend = ({}: ColorLegendProps) => {
  const { t } = useTranslation();

  return (
    <div className="enkrateia-bids-color-legend">
      <div>
        <Markdown>{t('pages.bidSheet.legend.preamble__markdownEnabled')}</Markdown>
        <div className="legend-entries">
          <div className="entry">
            <div className="dot green"></div>
            <div className="description">
              <Markdown>{t('pages.bidSheet.legend.green__markdownEnabled')}</Markdown>
            </div>
          </div>
          <div className="entry">
            <div className="dot orange"></div>
            <div className="description">
              <Markdown>{t('pages.bidSheet.legend.orange__markdownEnabled')}</Markdown>
            </div>
          </div>
          <div className="entry">
            <div className="dot red"></div>
            <div className="description">
              <Markdown>{t('pages.bidSheet.legend.red__markdownEnabled')}</Markdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorLegend;
